import { Box, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useState } from 'react';

import { DemoPlayPill, formatLength } from '~/components/whatsNew/WhatsNewShowcaseDialog';

export function WhatsNewDemoThumbnail({
  video,
  poster,
  title,
  onClick,
}: {
  video: string;
  poster?: string;
  title: string;
  onClick: () => void;
}) {
  const theme = useTheme();
  const [seconds, setSeconds] = useState<number | null>(null);
  const length = seconds === null ? null : formatLength(seconds);

  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      aria-label={`Watch the ${title} demo${length ? `, ${length}` : ''}`}
      sx={{
        position: 'relative',
        display: 'block',
        width: '100%',
        mt: 1,
        p: 0,
        border: 0,
        borderRadius: '10px',
        overflow: 'hidden',
        cursor: 'pointer',
        bgcolor: 'grey.900',
        '& .play': { transition: 'transform .2s ease' },
        '&:hover .play': { transform: 'scale(1.08)' },
        '&:focus-visible': { outline: `3px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
      }}
    >
      <Box
        component="video"
        src={video}
        poster={poster}
        preload="metadata"
        muted
        playsInline
        tabIndex={-1}
        aria-hidden
        onLoadedMetadata={(event: React.SyntheticEvent<HTMLVideoElement>) => {
          const { duration } = event.currentTarget;
          if (Number.isFinite(duration) && duration > 0) setSeconds(duration);
        }}
        sx={{
          display: 'block',
          width: '100%',
          aspectRatio: '16 / 10',
          objectFit: 'cover',
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'grid',
          placeItems: 'center',
          bgcolor: alpha(theme.palette.common.black, 0.18),
        }}
      >
        <DemoPlayPill length={length} size="small" />
      </Box>
    </Box>
  );
}
